module.exports = __webpack_public_path__ + "img/1505542651.a482a52d.jpg";